// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__7OHV8","left":"Virtual_left__brnr9","wrapper":"Virtual_wrapper__+oOGd"};